import React, { useState } from "react";
import HandleHttpErrors from "../../HandleHttpErrors";
import useAxiosPrivateUploadFile from "../../../hooks/useAxiosPrivateUploadFile";
const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({
  doc,
  handleCancelClick,
  increment,
  counter,
  setDocId,
  docOptions,
}) => {
  const [newDoc, setNewDoc] = useState(doc);
  const axiosPrivate = useAxiosPrivateUploadFile();

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setNewDoc((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const saveData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "mekhrazdocument/" + newDoc.id + "/",
          { id: doc.id, type: newDoc.doc_type },
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
          setDocId(null);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    saveData();
  };

  return (
    <tr>
      <td>שינוי סוג המסמך:</td>
      <td>
        <select name="doc_type" onChange={handleChange} value={newDoc.doc_type}>
          <option key="0" value="" defaultValue="0">
            בחר סוג מסמך
          </option>
          {docOptions?.map((a) => (
            <option key={a[0]} value={a[1]}>
              {a[1]}
            </option>
          ))}
        </select>
      </td>

      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          שמירה
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          ביטול
        </button>
      </td>
    </tr>
  );
};

export default Edit;
